import Platform from "../../../../libs/utility/Platform";
import { Theme } from "../../../components/constants";

export default {
    negativeMargin: {
        margin: Platform.isMobileView() ? "0px" : "-30px",
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0%",
    },
    stepImageDiv:{
        textAlign: "center"
    },
    stepTitleContainer:{
        textAlign: "center",
        marginTop: "10px",
    },
    stepTitleDesc: {
        fontSize: "16px",
        lineHeight: "25px",
        color: Theme.DISABLED_TEXT
    },
    goButtonStyle: {
        padding: "5px 30px",
    },
    welcomeFooter: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
        padding: "15px 0px",
        background: "#F5F6F8",
        borderTop: `1px solid ${Theme.PRIMARY_BORDER}`
    },
    footerRightColumn:{
        display: "flex",
        flexDirection: "column",
    },
    footerTextRow: {
        display: "flex",
        flexDirection: "row",
        gap: "40px"
    },
    footerTextHeading: {
        marginBottom: 0,
    }
}